/**
 * URL search-param key marking a `/login` redirect issued
 * because a signed-in visitor's Clerk session token was
 * momentarily unavailable server-side (`getToken()` returned
 * null). Its presence tells the login page to render the form
 * rather than auto-redirect back to the origin: the client
 * still reports a Clerk session, so bouncing back would
 * ping-pong.
 */
export const REAUTH_REQUIRED_PARAM = 'reauthRequired';
